var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-content__wrap",attrs:{"id":"app"}},[_c('Header'),_c('router-view'),(_vm.showSubscriber)?_c('Subscriber'):_vm._e(),(_vm.showHeaderAndFooter)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }